import { Box } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import RequireAuth from '../../components/athletes/RequireAuth';
import SchedulePage from '../schedule/SchedulePage';

// Phase C.5e.1 — SCHEDULE CONSOLIDATION. This file is now a THIN ROUTE
// WRAPPER — it contains NO schedule data-loading or presentation logic
// of its own. It resolves the two route params this route contributes
// (`programId`, `divisionId`) and hands them to the ONE canonical
// schedule page/controller (SchedulePage.js / scheduleController.js),
// which also backs TeamSchedulePage.js's own route. See
// scheduleController.js's own header for the full history of why this
// consolidation happened (a plain Team Head Coach's "View Full Division"
// link used to land HERE, at a separately-evolved, unfixed loader, even
// after Team-focused mode had already been fixed twice).
//
// Phase C.5e.2 — also resolves the optional `?fromTeam=` query param
// (set by a Team-focused "View Full Division →" link) and passes it
// through as `fromTeamId`, still just route context — SchedulePage.js
// itself decides what to do with it (see resolveDivisionBackNav()).
export default function DivisionSchedulePage() {
  const { programId, divisionId } = useParams();
  const [searchParams] = useSearchParams();
  const fromTeamId = searchParams.get('fromTeam') || null;
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Navbar />
      <RequireAuth><SchedulePage programId={programId} divisionId={divisionId} fromTeamId={fromTeamId} /></RequireAuth>
    </Box>
  );
}
